import React from 'react';

const Footer = () => {
  return (
    <footer id="contact" className="bg-gray-800 text-white text-center py-4">
      <div className="container mx-auto">
        <p>&copy; 2024 JewelryStore. All rights reserved.</p>
        <p>Contact us: info@jewelrystore.com</p>
      </div>
    </footer>
  );
};

export default Footer;
